import {
  LucideIcon,
  LucideMonitor,
  LucideLayoutGrid,
  LucideUsers,
  LucideDatabase,
  LucideAppWindow,
  LucideRadio,
  LucideBuilding,
  LucideBarChart3,
  LucideLayoutDashboard,
  LucideMonitorDown,
} from 'lucide-react'
import { IconType } from 'react-icons'

type NavigationRoutes =
  | 'Dashboard'
  | 'Accounts'
  | 'Analytics'
  | 'Players'
  | 'Screens'
  | 'Channels'
  | 'Widgets'
  | 'Apps'
  // | 'Templates'
  | 'Data'
  | 'Members'
  // | 'Settings'
  | 'Login'
  | 'LoginOTP'
  | 'Signup'
  | 'SignupVerify'

export interface RouteData {
  name: string
  href: string
  icon?: IconType | LucideIcon
  hidden?: boolean
  nestedRoutes?: RouteData[]
  adminOnly?: boolean
  godOnly?: boolean
  group?: string
}

export const Routes: Record<NavigationRoutes, RouteData> = {
  Dashboard: {
    name: 'Dashboard',
    href: '/dashboard',
    icon: LucideLayoutDashboard,
    group: 'Overview',
  },
  Accounts: {
    name: 'Accounts',
    href: '/accounts',
    icon: LucideBuilding,
    group: 'Admin',
    godOnly: true,
  },
  Analytics: {
    name: 'Analytics',
    href: '/analytics',
    icon: LucideBarChart3,
    group: 'Admin',
    godOnly: true,
  },
  Players: {
    name: 'Players',
    href: '/players',
    icon: LucideMonitorDown,
    group: 'Admin',
    godOnly: true,
  },
  Screens: {
    name: 'Screens',
    href: '/screens',
    icon: LucideMonitor,
    group: 'Core',
  },
  Channels: {
    name: 'Channels',
    href: '/channels',
    icon: LucideRadio,
    group: 'Core',
    adminOnly: true,
  },

  Widgets: {
    name: 'Widgets',
    href: '/widgets',
    icon: LucideLayoutGrid,
    group: 'Core',
  },
  Apps: {
    name: 'Apps',
    href: '/apps',
    icon: LucideAppWindow,
    group: 'Content',
    adminOnly: true,
  },
  // Templates: {
  //   name: 'Templates',
  //   href: '/templates',
  //   icon: LucideBookTemplate,
  //   group: 'Content',
  // },
  Data: {
    name: 'Data',
    href: '/assets',
    icon: LucideDatabase,
    group: 'Content',
  },
  Members: {
    name: 'Members',
    href: '/members',
    icon: LucideUsers,
    group: 'System',
    adminOnly: true,
  },
  // Settings: {
  //   name: 'Settings',
  //   href: '/settings',
  //   icon: LucideSettings,
  //   group: 'System',
  // },
  Login: {
    name: 'Login',
    href: '/auth/login',
    hidden: true,
  },
  LoginOTP: {
    name: 'Login',
    href: '/auth/login/verify',
    hidden: true,
  },
  Signup: {
    name: 'Signup',
    href: '/auth/signup',
    hidden: true,
  },
  SignupVerify: {
    name: 'SignupVerify',
    href: '/auth/signup/verify',
    hidden: true,
  },
}

export const NavRoutes = Object.values(Routes)
  .filter((route) => !route.hidden)
  .reduce(
    (groups, route) => {
      const group = route.group || 'Other'
      return {
        ...groups,
        [group]: [...(groups[group] || []), route],
      }
    },
    {} as Record<string, RouteData[]>
  )
